
import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const additionalFields_api = new AdditionalFieldsApi()

import godModeMixin from 'mixins/godModeMixin'

const operatorsGrop = {
  int: [
    'EQUALS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUAL_TO',
    'IS_SET',
    'IS_NOT_SET',
    'LESS_THAN',
    'LESS_THAN_OR_EQUAL_TO',
    'NOT_EQUALS',
  ],
  timespan: [
    'EQUALS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUAL_TO',
    'IS_SET',
    'IS_NOT_SET',
    'LESS_THAN',
    'LESS_THAN_OR_EQUAL_TO',
    'NOT_EQUALS',
  ],
  list: [
    'IS_NOT_SET',
    'IS_SET',
    'IN',
    'EXEPT',
  ],
  bool: [
    'IS_SET',
    'IS_NOT_SET'
  ],
  date: [
    'EQUALS',
    'EXEPT',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUAL_TO',
    'IS_NOT_SET',
    'IS_SET',
    'LESS_THAN',
    'LESS_THAN_OR_EQUAL_TO',
    'NOT_EQUALS',
  ],
  str: [
    'CONTAINS',
    'ENDS_WITH',
    'EQUALS',
    'IN',
    'IS_NOT_SET',
    'IS_SET',
    'START_WITH'
  ]
}

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  mixins: [godModeMixin],
  data() {
    return {
      service_spr: { // сервисный функционал
        triggers: {
          tenderStatusChanged: false,
          beforeOfferPeriodAutomaticallyEnds: false,
          beforePublishTender: false,
          beforeTenderComplete: false,
          afterTenderCanceled: false,
          changedSubmittedQuantity: true,
          ParticipantAnsweredOrganizerQuestion: false,
        },
        conditions: {},
        actions: {
          sendEmail: false,
          generateReport: false,
          startAdditionalApprovals: false,
          updateOfferPeriodEndDate: false,
          recalculateBidReducedPriceAndCriterias: true,
          //recalculateBidRedusedPriceInSaleInPartsTender: true
        },
      },
      mixin_spr: {
        triggers: [
          'tenderStatusChanged',
          'beforeOfferPeriodAutomaticallyEnds',
          'beforePublishTender',
          'beforeTenderComplete',
          'afterTenderCanceled',
          'changedSubmittedQuantity',
          'bidSubmit',
          'newPriceConfirmation',
          'participantAnsweredOrganizerQuestion'
          //$t('Automation.trigger.participantAnsweredOrganizerQuestion'
        ],
        conditions: [
          'tenderField',
          'additionalField',
          //$t('Automation.condition.existenceEmergencyProcurement'

        ],
        actions: [
          'sendEmail',
          'generateReport',
          'startAdditionalApprovals',
          // 'updateField', ждем рефакторинг от Димы. Сейчас в действиям приходит тип=полю
          //'deliveryPeriodEnd', // TimeSpan   JSON конкретного значения  Ждем модель объекта
          //'deliveryPeriodStart', // TimeSpan   JSON конкретного значения  Ждем модель объекта
          'updateOfferPeriodEndDate', // TimeSpan
          //'recalculateBidRedusedPriceInSaleInPartsTender',
          'recalculateBidReducedPriceAndCriterias',
          'startForceBpmByKey',
          'updateAdditionalField',
          'sendQuestion'
          //'sendEmailToActiveBids' // почему-то на беке этого нет
          //$t('Automation.action.sendQuestion'
        ],
        tags: [
          {
            key: 'TenderNumber',
            label: this.$t('Tenders.Number'),
            group: 'tender_prop',
            type: 'string',
            icon: 'text'
          },
          {
            key: 'TenderTitle',
            label: this.$t('Common.Name'),
            group: 'tender_prop',
            type: 'string',
            icon: 'text'
          },
          {
            key: 'TenderDate',
            label: this.$t('Tenders.DateOfCreation'),
            group: 'tender_prop',
            type: 'date',
            icon: 'calendar'
          },
          {
            key: 'StatusTitle',
            label: this.$t('Purchasing.Status'),
            group: 'tender_prop',
            type: 'object',
            icon: 'hyphen'
          },
          {
            key: 'CategoryCode',
            label: this.$t('Tenders.Category'),
            group: 'tender_prop',
            type: 'string',
            icon: 'text'
          },
          {
            key: 'InitialRate',
            label: this.$t('Tenders.Budget'),
            group: 'tender_prop',
            type: 'decimal',
            icon: 'sharp'
          },
          {
            key: 'ProlongationTitle',
            label: this.$t('Tenders.ExtensionRule'),
            group: 'tender_prop',
            type: 'string',
            icon: 'text'
          },
          {
            key: 'PublishFromDate',
            label: this.$t('Tenders.PublicationDate'),
            group: 'tender_prop',
            type: 'date',
            icon: 'calendar'
          },
          /*{
            key: 'FixedTradeStep',
            label: this.$t('Tenders.fixedTradingStep'),
            group: 'tender_prop',
            type: 'decimal',
            icon: 'sharp'
          },*/
          {
            key: 'OrganizationBidItem.SupplierTitle',
            label: this.$t('Tenders.supplierOrganization'),
            group: 'tender_prop',
            type: 'string',
            icon: 'text'
          },

          {
            key: 'LotsCount',
            label: this.$t('Tenders.Lots'),
            group: 'count_prop',
            type: 'int',
            icon: 'sharp'
          },
          {
            key: 'SupplierCount',
            label: this.$t('Tenders.Participants'),
            group: 'count_prop',
            type: 'int',
            icon: 'sharp'
          },

          /*{
            key: 'BiddingStepAvailability',
            label: 'Крок ставки',
            group: 'has_prop',
            type: 'bool',
            icon: 'checkbox'
          },
          {
            key: 'ExistenceOfCriteries',
            label: 'Критерії',
            group: 'has_prop',
            type: 'bool',
            icon: 'checkbox'
          },*/

          {
            key: 'TenderId',
            label: this.$t('Tenders.tenderAfter'),
            group: 'key_prop',
            type: 'int',
            icon: 'sharp'
          },
          {
            key: 'OrganizationId',
            label: capitalizeFirstLetter(this.$tc('Common.Organizations', 5)),
            group: 'key_prop',
            type: 'int',
            icon: 'sharp'
          },
          /*{
            key: 'ContactId',
            label: this.$t('Common.contactPerson'),
            group: 'key_prop',
            type: 'int',
            icon: 'sharp'
          },*/
          /*{
            key: 'BiddingTypeId',
            label: this.$t('Common.typeTender'),
            group: 'key_prop',
            type: 'int',
            icon: 'sharp'
          },*/
          /*{
            key: 'CurrencyId',
            label: this.$t('Common.currencies'),
            group: 'key_prop',
            type: 'int',
            icon: 'sharp'
          },*/

          {
            key: 'Now',
            label: this.$t('Common.currentDateTime'),
            group: 'var_prop',
            type: 'date',
            icon: 'calendar'
          },


          {
            key: 'OrganizerTenderLink',
            label: `${this.$t('Tenders.shareLabel')} (${this.$t('Tenders.Customer')})`,
            group: 'var_prop',
            type: 'string',
            icon: 'link'
          },
          {
            key: 'SupplierTenderLink',
            label: `${this.$t('Tenders.shareLabel')} (${this.$t('Tenders.Member')})`,
            group: 'var_prop',
            type: 'string',
            icon: 'link'
          },
        ]
      },
      mixin_operators: [
        'EQUALS',
        'NOT_EQUALS',
        'IS_SET',
        'IS_NOT_SET',
        'IN',
        'EXEPT',
        'GREATER_THAN',
        'LESS_THAN',
        'GREATER_THAN_OR_EQUAL_TO',
        'LESS_THAN_OR_EQUAL_TO',
        'CONTAINS',
        'START_WITH',
        'ENDS_WITH'
      ],
      mixin_tenderFields: [
        { operators: operatorsGrop.list, label: 'tenderType' },
        { operators: operatorsGrop.list, label: 'tenderStatus' },
        { operators: operatorsGrop.list, label: 'tenderCategory' },
        { operators: operatorsGrop.list, label: 'tenderCurrency' },
        { operators: operatorsGrop.list, label: 'tenderContact' },
        { operators: operatorsGrop.list, label: 'tenderDepartment' },

        { operators: operatorsGrop.bool, label: 'existenceEmergencyProcurement' },
        { operators: operatorsGrop.bool, label: 'biddingStepAvailability' },
        { operators: operatorsGrop.bool, label: 'existenceOfCriteries' },
        { operators: operatorsGrop.bool, label: 'autoRenewalTender' },
        { operators: operatorsGrop.bool, label: 'availabilityAttachments' },

        { operators: operatorsGrop.int, label: 'tenderBudget' },
        { operators: operatorsGrop.int, label: 'tenderLotsCount' },
        { operators: operatorsGrop.int, label: 'invitedParticipantsCount' },
        { operators: operatorsGrop.int, label: 'suppliersCount' },

        { operators: operatorsGrop.timespan, label: 'timeUntilTenderCompleted' },
      ],
      mixin_additionalFields: {
        loading: false,
        items: null,
        operators: {
          'DATE_TIME': operatorsGrop.date,
          'DECIMAL': operatorsGrop.int,
          'STRING': operatorsGrop.str,
          'TEXT': operatorsGrop.str,
          'URL': operatorsGrop.str,
          'EMAIL': operatorsGrop.str,
          'PHONE': operatorsGrop.str,
          'CHECKBOX': operatorsGrop.bool,
          'DROPDOWN': operatorsGrop.list,
        }
      },
      mixin_updateAutomationDateTypes: {
        'IncreaseDateByCountOfCalendarDays': {
          component: 'automationActionDateCheckTime',
          options: {
            label: this.$t('Tenders.CountCalendarDay'),
          },
        },
        'IncreaseDateByCountOfWorkingDays': {
          component: 'automationActionDateCheckTime',
          options: {
            label: this.$t('Tenders.CountWorkDay'),
          },
        },
        'IncreaseBySpecificTime': {
          component: 'automationActionTime'
        },
        'SetDateTime': {
          component: 'automationActionDateTime'
        },
        'CurrentDateTrigger': {
          component: null
        },
      },
      mixin_updateAdditionalField: {
        'DATE_TIME': {
          updateTypes: ['IncreaseDateByCountOfCalendarDays', 'IncreaseDateByCountOfWorkingDays', 'SetDate', 'CurrentDateTrigger']
        },
        'DECIMAL': {
          updateTypes: ['SetNewValue', 'Increase', 'Decrease',]
        },
        'STRING': {
          updateTypes: ['SetNewValue']
        },
        'TEXT': {
          updateTypes: ['SetNewValue']
        },
        'URL': {
          updateTypes: ['SetNewValue']
        },
        'EMAIL': {
          updateTypes: ['SetNewValue']
        },
        'PHONE': {
          updateTypes: ['SetNewValue']
        },
        'CHECKBOX': {
          updateTypes: ['SetNewValue']
        },
        'DROPDOWN': {
          updateTypes: ['SetNewValue']
        },
      }
    }
  },
  methods: {
    /**
     * Получить все теги из строки
     * @param {String} innerString  входящая строка для обработки
     * @returns
     */
    $_getAllTagFromString(innerString) {
      const regex = /{([^}]+)}/g
      return innerString.match(regex)
    },
    /**
     * Проверить что используются только корректные теги
     * @param {String} innerString  входящая строка для обработки
     */
    $_checkCorrectTagsOnString(innerString) {
      if (!innerString?.trim()) {
        return []
      }
      const allTags = this.$_getAllTagFromString(innerString)
      if (!allTags?.length) {
        return []
      }
      const errorTags = []
      allTags.forEach((tag) => {
        const tagKey = tag
          .replace('{','')
          .replace('}','')
        if (!this.mixin_spr.tags.find(i => i.key === tagKey)) {
          errorTags.push(tagKey)
        }
      })
      return errorTags
    },
    $_getAdditionalFieldRule(type, that) {
      let validation = [
        {
          required: true,
          trigger: 'change',
          max: 4000,
          validator(rule, value, callback) {
            if (!that.additionalField?.value) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        }
      ]
      if (type === 'URL') {
        validation.push({
          trigger: 'change',
          validator(rule, value, callback) {
            const needCheck = ['EQUALS', 'EXEPT', 'NOT_EQUALS']
            if (!needCheck.includes(that.compareType)) {
              callback()
            }
            const regex = new RegExp(/^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\\/~+#-]*[\w@?^=%&amp;\\/~+#-])?$/)
            if (!regex.test(that.additionalField?.value)) {
              callback(new Error(that.$t('Validate.LinkRules')))
            }
            callback()
          },
        })
      } else if (type === 'PHONE') {
        validation.push({
          trigger: 'change',
          validator(rule, value, callback) {
            const needCheck = ['EQUALS', 'EXEPT', 'NOT_EQUALS']
            if (!needCheck.includes(that.compareType)) {
              callback()
            }
            const regex = new RegExp(/^\+\d{12}$/)
            if (!regex.test(that.additionalField?.value)) {
              callback(new Error(that.$t('Tenders.PhoneNumRules')))
            }
            callback()
          },
        })
      } else if (type === 'EMAIL') {
        validation.push({
          trigger: 'change',
          validator(rule, value, callback) {
            const needCheck = ['EQUALS', 'EXEPT', 'NOT_EQUALS']
            if (!needCheck.includes(that.compareType)) {
              callback()
            }
            const regex = new RegExp(/^\s*([A-Za-z0-9_\-.'])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})\s*$/)
            if (!regex.test(that.additionalField?.value)) {
              callback(new Error(that.$t('Tenders.MailRules', {mail: ''})))
            }
            callback()
          },
        })
      }
      return validation
    },
    $_getAdditionalFields() {
      return new Promise((resolve) => {
        if (this.mixin_additionalFields.loading) {
          resolve()
          return
        }
        this.mixin_additionalFields.loading = true
        additionalFields_api.getAdditionalFieldsByBindingConditions({bindingLevel: ['TENDER']})
          .then(async res => {
            this.mixin_additionalFields.items = res || []
          })
          .finally(() => {
            this.mixin_additionalFields.loading = false
            resolve()
          })
      })
    }
  },
  computed: {
    $_accessAutomations() {
      const isAccess = (this.$acl.check('tenderAdmin') && this.$can('use', 'automationAvaliable')) || this.$acl.check('isGoodMode')
      return isAccess || this.mixin_isGodMode
    },
    $_additionalFields() {
      if (this.mixin_additionalFields.loading) {
        return []
      }
      return this.mixin_additionalFields.items?.filter(i => i.bindingLevel === 'TENDER')
    },
    $_showParametersWithOperator() {
      if (['IS_SET', 'IS_NOT_SET'].includes(this.compareType)) {
        return false
      }
      return !!this.compareType
    }
  },
}
